import * as React from "react";
import { ASSORTMENTS } from "constants/integration/assortments";
import { FormatMessage as FormatMessageComponent } from "react-globalize";
import Reminders from "components/product-media/components/reminders";

interface IProps {
    items: string[];
    wasUpdated: boolean;
}

export const SummarizeColumnsUpdated: React.FC<IProps> = ({ items, wasUpdated }) => {
    const title = wasUpdated ? (
        <FormatMessageComponent
            path="[strong]|count|[strong] existing attributes have been [strong]updated:[strong]"
            elements={{ strong: <b /> }}
            variables={{
                count: items.length,
            }}
        />
    ) : (
        <FormatMessageComponent
            path="Existing door attributes to be [strong]updated[strong] with the new values from your file:"
            elements={{ strong: <b /> }}
        />
    );
    return (
        <Reminders
            title={title}
            shouldUseCurrentColor
            dataTestTitle={ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.UPDATED.TITLE}
            dataTestList={ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.UPDATED.LIST}
        >
            {items.map((col, index) => (
                <li
                    key={`${col}-${index}`}
                    data-test={`${ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.UPDATED.ITEM}-${index}`}
                >
                    {col}
                </li>
            ))}
        </Reminders>
    );
};
